<template>
    <div class="nasabah">
        <p class="title">Nasabah Terdaftar</p>
        <div class="content">
            <div class="table-responsive">
                <div class="total-user" v-show="role == 13">Total : {{ count_data }}</div>
                <table class="table table-striped table-bordered" id="my-table">
                    <thead class="text-center text-bold">
                        <tr>
                            <th>No</th>
                            <th>Nama Lengkap</th>
                            <th>Email</th>
                            <th>
                                Platform
                                <div class="form-group mb-0">
                                    <select name="" id="" v-model="platform" @change="filterPlatform">
                                        <option value="">All</option>
                                        <option v-for="(data, i) in dataPlatform" :key="i" :value="data.code">{{ data.name }}</option>
                                    </select>
                                </div>
                            </th>
                            <th>No Telepon</th>
                            <th>No KTP</th>
                            <th>NPWP</th>
                            <th class="action">Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="lengthData">
                        <td colspan="10" v-show="loadingData" style="text-align: center">
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </td>
                        <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false">
                            <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                            <td>{{ data.fullname ? data.fullname : "-" }}</td>
                            <td>
                                {{ data.user.email }}
                            </td>
                            <td>
                                <div v-for="platformData in data.platform" :key="platformData.code">
                                    {{ "- " + platformData.name }}
                                </div>
                            </td>
                            <td>{{ data.user.phonenumber }}</td>
                            <td>{{ data.ktp_no }}</td>
                            <td>{{ data.npwp_no }}</td>
                            <!-- <td>{{ data.created_at | formatDateTime }}</td> -->
                            <td>
                                <router-link :to="'/nsb-detail/' + data._id" v-if="checkAccess('get-detail')">
                                    <button type="button" class="buttons btn-info btn-xs">
                                        Detail
                                    </button>
                                </router-link>
                                <button
                                    type="button"
                                    class="buttons btn-danger btn-xs"
                                    @click="sendId(data._id, data.fullname)"
                                    v-show="role != 13"
                                    v-if="checkAccess('block')"
                                >
                                    Blacklist
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="8" class="text-center">
                                No Data
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="count_data"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @change="handlePageChange"
                    v-show="count_data > 10"
                ></b-pagination>
            </div>
            <b-modal ref="modalBlock" hide-footer title="Block Nasabah Terdaftar">
                <form @submit.prevent="blacklist">
                    <div class="modal-body">
                        Apakah Anda yakin memasukan akun <b>{{ fullname }}</b> ke dalam daftar blacklist?
                        <textarea
                            name="input message"
                            cols="60"
                            rows="5"
                            placeholder="Berikan alasan atau kekurangan isian/berkas nasabah "
                            v-model="$v.messageNasabah.$model"
                            minlength="30"
                        ></textarea>
                        <div v-if="$v.messageNasabah.$error">
                            <div class="error" v-if="!$v.messageNasabah.required">
                                Alasan tidak boleh kosong
                            </div>
                            <div class="error" v-if="!$v.messageNasabah.minLength">
                                Alasan minimal 30 karakter
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn-primer" aria-hidden="true">
                            <b-spinner small variant="ligth" v-if="isLoading" style="width: 20px; height: 20px"></b-spinner>
                            <span v-else>Setuju</span>
                        </button>
                    </div>
                </form>
            </b-modal>
            <!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Blacklist Nasabah Terdaftar
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="blacklist">
              <div class="modal-body">
                Apakah Anda yakin memasukan akun {{ fullname }} ke dalam daftar blacklist?
                <textarea name="input message" placeholder="Berikan alasan ke nasabah" rows="4" v-model="$v.messageNasabah.$model"></textarea>
                <div v-if="$v.messageNasabah.$error">
                  <div class="error" v-if="!$v.messageNasabah.required">
                    Alasan tidak boleh kosong
                  </div>
                  <div class="error" v-if="!$v.messageNasabah.minLength">
                    Alasan minimal 30 karakter
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn-primer" aria-hidden="true">
                  <span v-show="!isLoading">Setuju</span>
                  <Loading v-show="isLoading" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div> -->
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
    data() {
        return {
            dataNsb: [],
            id: "",
            currentPage: 1,
            perPage: 10,
            value: 2,
            number: 1,
            messageNasabah: "",
            lengthData: 1,
            loadingData: false,
            hiddenCards: [],
            idToggle: null,
            showToggle: false,
            count_data: "",
            isLoading: false,
            role: "",
            fullname: "",
            platform: "",
            dataPlatform: [],
        };
    },
    validations: {
        messageNasabah: {
            required,
            minLength: minLength(30),
        },
    },
    mounted() {
        this.role = localStorage.getItem("role");
        axios.get("/v2/master_data/platform").then((res) => {
            this.dataPlatform = res.data.data;
        });
        this.getData(this.currentPage, this.platform);
    },
    methods: {
        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        filterPlatform() {
            this.getData(this.currentPage, this.platform);
        },
        async getData(value, platform) {
            this.loadingData = true;
            let role = localStorage.getItem("role");
            let url;
            let setPage = (value - 1) * this.perPage;
            let urlAdmin;
            if (role == 13) {
                url = "/v1/nasabah/get/bank?status_nasabah=4&is_trading=true&offset=" + setPage + "&limit=10";
            } else {
                if (role == "0") {
                    urlAdmin = "superadmin";
                } else {
                    urlAdmin = "admin-broker";
                }
                url = "/v2/" + urlAdmin + "/kyc/customers?status=7&limit=10&offset=" + setPage + "&platform_code=" + platform;
            }
            await axios
                .get(url)
                .then((res) => {
                    this.loadingData = false;
                    this.count_data = res.data.data.total;
                    this.dataNsb = res.data.data.customers;
                    if (this.dataNsb == 0) {
                        this.lengthData = 0;
                    } else {
                        this.lengthData = this.dataNsb.length;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.loadingData = false;
                });
        },

        toggle(e) {
            if (this.idToggle == e) {
                this.idToggle = null;
            } else {
                this.idToggle = e;
            }
        },
        checkAccess(value) {
            let service_access = localStorage.getItem("access");
            let dataAcces = JSON.parse(service_access);
            let returnValue = false;
            for (let i = 0; i < dataAcces.length; i++) {
                let access = dataAcces[i].access;
                for (let j = 0; j < access.length; j++) {
                    if (access[j] == value) {
                        returnValue = true;
                    }
                }
            }
            return returnValue;
        },
        blacklist() {
            this.$v.messageNasabah.$touch();
            if (this.$v.messageNasabah.$error) {
                return;
            }
            this.isLoading = true;
            axios
                .put("/v2/admin-broker/kyc/block/" + this.id, {
                    description: this.messageNasabah,
                })
                .then((res) => {
                    let status = res.data.data.status_code;
                    this.isLoading = false;
                    if (status == "00") {
                        let id_activity = res.data.data.activity_id;
                        this.$toast.success("Blacklist user berhasil");
                        // this.$notify({
                        //   group: "foo",
                        //   title: "<h5>Blacklist user berhasil</h5>",
                        //   type: "success",
                        // });
                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    } else {
                        this.$toast.error("Nasabah tidal Valid");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        sendId(id, name) {
            this.id = id;
            this.fullname = name;
            this.$refs["modalBlock"].show();
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        rows() {
            return this.count_data;
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var like = this;

            like.resultCount = this.dataNsb.length;
            if (this.currentPage >= this.totalPages) {
                like.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.total-user {
    font-weight: bold;
    text-align: right;
    margin-bottom: 5px;
    margin-right: 10px;
}
.wrap-dropdown {
    position: relative;
}

.dropdown-link {
    display: block;
    position: absolute;
    right: 160px;
    background: #fff;
    top: -23px;
    padding: 10px 15px;
}

.dropdown-link li {
    height: 35px;
    margin-bottom: 5px;
    line-height: 2.5;
    cursor: pointer;
}

.icon-toggle {
    cursor: pointer;
}

.lds-ring {
    display: inline-block;
    /* position: absolute; */
    width: 30px;
    height: 30px;
    /* top: 4px; */
    /* left: 39%; */
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 6px;
    border: 6px solid #1f354a;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

table {
    color: #707070 !important;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 60px;
}

.action {
    width: 186px;
}
</style>
